/**
 * Sidebar menu configurations for different roles
 */

export const ADMIN_MENU_ITEMS = [
  {
    path: "/admin-dashboard",
    label: "Dashboard",
    icon: "dashboard.svg"
  },
  {
    path: "/admin-dashboard/buyers",
    label: "Registration",
    icon: "registeration.svg",
    submenu: [
      { path: "/admin-dashboard/buyers", label: "Buyers" },
      { path: "/admin-dashboard/sellers", label: "Sellers" },
      { path: "/admin-dashboard/project-managers", label: "Project Managers" }
    ]
  },
  {
    path: "/admin-dashboard/rfqs",
    label: "RFQs",
    icon: "rfqs.svg"
  },
  {
    path: "/admin-dashboard/contracts",
    label: "Contracts",
    icon: "contracts.svg"
  },
  {
    path: "/admin-dashboard/projects",
    label: "Projects",
    icon: "dashboard.svg"
  },
  {
    path: "/admin-dashboard/send-notifications",
    label: "Send Notifications",
    icon: "notification.svg"
  }
];

export const SELLER_MENU_ITEMS = [
  {
    path: "/seller-dashboard",
    label: "Dashboard",
    icon: "dashboard.svg"
  },
  {
    path: "/seller-dashboard/requirements",
    label: "Requirements",
    icon: "requirement.svg"
  },
  {
    path: "/seller-dashboard/projects",
    label: "Projects",
    icon: "projects.svg"
  },
  {
    path: "/seller-dashboard/users",
    label: "Users",
    icon: "users.svg"
  },
  {
    path: "/seller-dashboard/settings",
    label: "Settings",
    icon: "setting.svg"
  }
];

export const PROJECT_MANAGER_MENU_ITEMS = [
  {
    path: "/manager-dashboard",
    label: "Dashboard",
    icon: "dashboard.svg"
  },
  {
    path: "/manager-dashboard/projects",
    label: "Projects",
    icon: "projects.svg"
  },
  {
    path: "/manager-dashboard/settings",
    label: "Settings",
    icon: "setting.svg"
  }
];

export const BUYER_MENU_ITEMS = [
  {
    path: "/buyer-dashboard",
    label: "Dashboard",
    icon: "dashboard.svg"
  },
  {
    path: "/buyer-dashboard/requirements",
    label: "Requirements",
    icon: "requirement.svg"
  },
  {
    path: "/buyer-dashboard/projects",
    label: "Projects",
    icon: "projects.svg"
  },
  {
    path: "/buyer-dashboard/users",
    label: "Users",
    icon: "users.svg"
  },
  {
    path: "/buyer-dashboard/settings",
    label: "Settings",
    icon: "setting.svg"
  }
];
